module.exports = __webpack_public_path__ + "img/redo.26fe2105.svg";